import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "../../../context/Snackbar";
import { DisableRegistration } from "../../../core/interfaces/DisableRegistration"
import ParamTypes from "../../../core/interfaces/ParamTypes";
import { getByIdResearchQuestion, postResearchQuestion, putResearchQuestion, postValueSearch, postTypeOriginQuestion, putTypeOriginQuestion, putValueSearch } from "../../rating/Assesment.service";
import { AxiosError, AxiosResponse } from 'axios';
import Form from '../register/Form.component';
import {ResearchQuestionInterface, PutResearchQuestionInterface} from "../interfaces/ResearchQuestion";
import { INITIAL_VALUES } from "../utils/INITIAL_VALUES";
import {mapValueResearch, mapTypeOriginQuestion} from "../utils/helpers/Mapper";
import { getUser } from "../../../core/auth/auth";
import ValueSearch from "../interfaces/ValueSearch";
import TypeOriginQuestion from "../interfaces/TypeOriginQuestion";

export default function Register({ disabled }: DisableRegistration) {

    let history = useHistory();
    let { id } = useParams<ParamTypes>();
    const {setSnackbar} = useSnackbar();
    const [reload, setReload] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [assessment, setAssessment] = useState<ResearchQuestionInterface>(INITIAL_VALUES);

    useEffect(() => {
       
    }, []);

    const onSubmit = async (data: ResearchQuestionInterface) => {
        setIsSubmitting(true);

        const {sAMAccountName} = getUser();
        let idValueSearch: ValueSearch;
        let idTypeOriginQuestion: TypeOriginQuestion;

        let typeOriginQuestion = mapTypeOriginQuestion(data);
        let valueResearch = mapValueResearch(data);

        if (id) {
            typeOriginQuestion.id = assessment.idTipoOrigemPergunta.id;
            valueResearch.id = assessment.idValoresPesquisa.id;
        }

        setTimeout(async () => {
            const responseOriginQuestion: Promise<AxiosResponse<TypeOriginQuestion>> = await id ? putTypeOriginQuestion(typeOriginQuestion) : postTypeOriginQuestion(typeOriginQuestion);

            responseOriginQuestion.then((res) => {
                idTypeOriginQuestion = res.data;

                setTimeout(async () => {
                    const responseValueSearch: Promise<AxiosResponse<ValueSearch>> = await id ? putValueSearch(valueResearch) : postValueSearch(valueResearch);

                    responseValueSearch.then((res) => {
                        idValueSearch = res.data;

                        let researchQuestion = {...data, idUsuario: sAMAccountName};
                        
                        if (!id) {
                            researchQuestion.idTipoOrigemPergunta = idTypeOriginQuestion;
                            researchQuestion.idValoresPesquisa = idValueSearch;
                        } 
                        
                        setTimeout(async () => {
                            
                            let putQuestion: PutResearchQuestionInterface = {
                                id: id,
                                dsPesquisa: data.dsPesquisa,
                                flAtiva: data.flAtiva,
                                flPadrao: data.flPadrao,
                                flNPS: data.flNPS,
                                idUsuario: sAMAccountName,
                                idValoresPesquisa: assessment.idValoresPesquisa.id,
                                idTipoOrigemPergunta: assessment.idTipoOrigemPergunta.id
                            };

                            const response: Promise<AxiosResponse<ResearchQuestionInterface | PutResearchQuestionInterface>> = await id ? putResearchQuestion(putQuestion, id) : postResearchQuestion(researchQuestion);
                            response.then((res) => {
                                setSnackbar({ msg: `Avaliação foi ${id ? 'atualizada' : 'cadastrada'} com sucesso!`, type: 'success' });
                                history.push(`/avaliacao-loja`);
                            }).catch((error: AxiosError) => {
                                console.log('Error response Assessment');
                                console.log('Error ao submeter Avaliação', error);
                                setSnackbar({ msg: `Erro ao ${id ? 'atualizar' : 'cadastrar'} avaliação!`, subMsg: error.response?.data.message, type: 'error' });
                            }).finally(() => {
                                setIsSubmitting(false);
                            })
                        }, 1000*1.5)
                        

                    }).catch((error: AxiosError) => {
                        console.log('Error response ValueSearch');
                        console.log('Error ao submeter Avaliação', error);
                        setSnackbar({ msg: `Erro ao cadastrar avaliação!`, subMsg: error.response?.data.message, type: 'error' });
                    })

                }, 1000*1.5)

            }).catch((error: AxiosError) => {
                console.log('Error response OriginQuestion');
                console.log('Error ao submeter Avaliação', error);
                setSnackbar({ msg: `Erro ao cadastrar avaliação!`, subMsg: error.response?.data.message, type: 'error' });
            })

        }, 1000*1.5)
    };

    return (
        <Form handleSubmitForm={onSubmit} initialValues={assessment} disabled={disabled} request={isSubmitting} id={id} >

        </Form>
    )

}